import * as amplitude from '@amplitude/unified';

const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY as string;

let initialized = false;

export const initAmplitude = () => {
  if (import.meta.env.VITE_ENABLE_AMPLITUDE !== 'true' || !AMPLITUDE_API_KEY) return;

  amplitude.initAll(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: {
        attribution: true,
        fileDownloads: true,
        formInteractions: true,
        pageViews: true,
        sessions: true,
        elementInteractions: true,
        networkTracking: true,
        webVitals: true,
        frustrationInteractions: {
          thrashedCursor: true,
          errorClicks: true,
          deadClicks: true,
          rageClicks: true,
        },
      },
    },
    sessionReplay: {
      sampleRate: 1,
    },
  });

  initialized = true;
};

export const track: typeof amplitude.track = (...args) =>
  initialized ? amplitude.track(...args) : { promise: Promise.resolve({ event: { event_type: '' }, code: 0, message: '' }) };

export const identify: typeof amplitude.identify = (...args) =>
  initialized ? amplitude.identify(...args) : { promise: Promise.resolve({ event: { event_type: '' }, code: 0, message: '' }) };

export const { Identify } = amplitude;
